import type * as Types from 'app/types/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopMetaQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.ShopMetaWhereInput>;
}>;

export type ShopMetaQueryResponse = {
  shopMeta?: Types.Maybe<
    Pick<Types.ShopMetaConnection, 'totalCount'> & {
      edges?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<Types.ShopMetaEdge, 'cursor'> & {
              node?: Types.Maybe<
                Pick<Types.ShopMeta, 'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'>
              >;
            }
          >
        >
      >;
      pageInfo: Pick<
        Types.PageInfo,
        'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
      >;
    }
  >;
};

export const ShopMetaDocument = `
    query ShopMeta($after: Cursor, $before: Cursor, $first: Int, $last: Int, $where: ShopMetaWhereInput) {
  shopMeta(
    after: $after
    before: $before
    first: $first
    last: $last
    where: $where
  ) {
    edges {
      cursor
      node {
        createdAt
        id
        key
        updatedAt
        value
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

export const useShopMetaQuery = <TData = ShopMetaQueryResponse, TError = unknown>(
  variables?: ShopMetaQueryVariables,
  options?: UseQueryOptions<ShopMetaQueryResponse, TError, TData>,
) => {
  return useQuery<ShopMetaQueryResponse, TError, TData>(
    variables === undefined ? ['ShopMeta'] : ['ShopMeta', variables],
    appFetcher<ShopMetaQueryResponse, ShopMetaQueryVariables>(ShopMetaDocument, variables),
    options,
  );
};

useShopMetaQuery.getKey = (variables?: ShopMetaQueryVariables) =>
  variables === undefined ? ['ShopMeta'] : ['ShopMeta', variables];
